import { render, staticRenderFns } from "./TableCompanyTokens.vue?vue&type=template&id=3bd781d0"
import script from "./TableCompanyTokens.vue?vue&type=script&lang=js"
export * from "./TableCompanyTokens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports